// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__PStM-","consentsList":"PatientConsents_consentsList__15CbZ","consentsListEmpty":"PatientConsents_consentsListEmpty__2iS4N"};